<template>
  <div>
    <div v-if="calculatesZipcodeCache" class="alert alert-info">
      Hinweis: Da der Cache für dynamische PLZ berechnet wird, wird die
      Einstellung `dynamisch` erst später angewendet. Die Fakes behalten für
      diese Zeit den alten Wohnort.
    </div>
    <section>
      <resource
        title="Ändern"
        resource="customerProfile"
        resourceName="Fake"
        :staticMode="isDeleted"
        :original="original"
        :attributes="[
          {
            name: 'sex',
            label: 'Geschlecht',
            type: 'SexSelector'
          },
          {
            name: 'name',
            label: 'Name'
          },
          {
            name: 'country_iso3166',
            label: 'Land',
            type: 'OptionSelector',
            hideable: true,
            hideEvent: 'has-dynamic-zipcode'
          },
          {
            name: 'zipcode',
            label: 'PLZ',
            col: 3,
            hideable: true,
            hideEvent: 'has-dynamic-zipcode'
          },
          {
            name: 'privacy_postal_code_number_de',
            label: 'Angezeigte PLZ Nummern',
            col: 1
          },
          {
            name: 'privacy_postal_code_number_at_ch',
            label: 'Angezeigte PLZ Nummern AT/CH',
            col: 1,
            hideable: true,
            reverseHide: true,
            hideEvent: 'has-dynamic-zipcode'
          },
          {
            name: 'has_dynamic_zipcode',
            label: 'Dynamische PLZ',
            type: 'CheckboxSelector',
            cantDisable: true
          },
          {
            name: 'birthday',
            label: 'Geburtsdatum',
            type: 'BirthdaySelector',
            withRandomSelector: true
          },
          {
            name: 'physique',
            label: 'Figur',
            type: 'OptionSelector'
          },
          {
            name: 'i_search_for_activity',
            label: 'Ich suche',
            type: 'MultiOptionSelector',
            multiSelect: true
          },
          {
            name: 'interested_in_gender',
            label: 'Interessiert an',
            type: 'SexSelector',
            multiSelect: true
          },
          {
            name: 'height_in_cm',
            label: 'Größe (cm)',
            type: 'SliderSelector',
            max: 220,
            min: 140
          },
          {
            name: 'admin_notes',
            label: 'Admin Info',
            type: 'TextareaSelector',
            rows: 5
          }
        ]"
      >
        <div slot="title">
          <h4>
            Fake-Profil bearbeiten
            <span v-if="isDeleted" class="badge badge-danger ml-3"
              >GELÖSCHT</span
            >
          </h4>
        </div>
      </resource>
      <MediaEditCard
        v-if="!isDeleted"
        :profile="customer"
        title="Fakes Media"
      ></MediaEditCard>
    </section>
  </div>
</template>

<script lang="babel">
import store from "@/store";
import MediaEditCard from "src/components/UIComponents/Cards/MediaEditCard.vue";

export default {
  components: {
    MediaEditCard
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('customerProfile/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
      {
        name: 'fake',
      },
      {
        name: 'with-media',
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['customerProfile/find'](this.id);
    },
    isDeleted() {
      return Boolean(this.original.deleted_at);
    },
    customer() {
      return this.$store.getters["customerProfile/find"](this.id);
    },
    calculatesZipcodeCache() {
      return this.$store.getters["backgroundTask/running"]('calculate-zipcode-cache');
    }
  }
};
</script>
